<template>
  <div class="js-author-detail">
    <div class="content-header">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'shopList' }">店铺列表</router-link>
        </li>
        <li class="active">详情</li>
      </ol>
    </div>
    <div class="content-from">
      <el-form ref="formName" :model="shop" label-width="auto">
        <el-form-item label="店铺名称">
            <el-input v-model="shop.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="营业执照">
          <el-image style="height: 100px; width: 100px" :src="dynamicPath + shop.businessLicense">
            <div slot="error" class="image-slot">
              <el-image title="加载失败" src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png" />
            </div>
          </el-image>
        </el-form-item>
        <el-form-item label="LOGO">
          <el-image style="height: 100px; width: 100px" :src="dynamicPath + shop.iconPath">
            <div slot="error" class="image-slot">
              <el-image title="加载失败" src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png" />
            </div>
          </el-image>
        </el-form-item>
        <el-form-item label="座机电话">
            <el-input v-model="shop.landlineTelephone" disabled></el-input>
        </el-form-item>
        <el-form-item label="营业时间">
            <el-input v-model="shop.businessDate" disabled></el-input>
        </el-form-item>
        <el-form-item label="所属行业">
          <el-select v-model="shop.typeId" disabled>
            <el-option v-for="item in shopTypes" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人">
            <el-input v-model="shop.contactsPeople" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
            <el-input v-model="shop.contactsTelephone" disabled></el-input>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input :value="shop.province + shop.city + shop.area + shop.address" disabled></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="check" size="small" v-if="shop.status == 'APPLY'">审核</el-button>
          <el-button @click="$router.back(-1)" size="small">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <check-shop ref="checkShop" :success="success"></check-shop>
  </div>
</template>
<script>
import CheckShop from './components/check-shop';
export default {
    components: {
        CheckShop
    },
    data() {
        return {
            shop: {},
            shopId: "",
            dynamicPath:config.dynamicResourcePath,
            shopTypes: [],
        };
    },
    created() {
        this.shopId = this.$route.query.shopId;
        if (this.shopId) {
            this.shopDetail();
            this.findShopType();
        }
    },
    methods: {
        findShopType() {
          var _this = this;
          _this.$common.ajaxRequest({
              url: '/shopType/pageShopType',
              data: {
                  limit: -1
              },
              success: resp => {
                  _this.shopTypes = resp.items || [];
              }
          })
        },
        shopDetail() {
            var _this = this;
            _this.$common.ajaxRequest({
                url: '/shop/detailShop',
                data: {
                    shopId: _this.shopId
                },
                success: resp => {
                    _this.shop = resp.item || {};
                }
            })
        },
        success() {
            this.$refs['checkShop'].close();
            this.$router.back(-1);
        },
        check() {
            this.$refs['checkShop'].openDialog(this.shopId)
        },
    },
};
</script>